import { render } from "./TooltipBuffer.vue?vue&type=template&id=4483f547"
import script from "./TooltipBuffer.vue?vue&type=script&lang=js"
export * from "./TooltipBuffer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__